<template>
    <div class="app-container">
        <div class="div-align-lr page-top-but">
            <div></div>
            <div style="width=250px"><el-input placeholder="请输入内容" v-model="searchPatrolVal" class="input-with-select">
                <el-select v-model="searchPatrolSelectVal" slot="prepend" placeholder="请选择">
                    <el-option label="设备编号" value="device_id"></el-option>
                    <el-option label="设备序号" value="grm"></el-option>
                    <el-option label="客户姓名" value="realname"></el-option>
                    <el-option label="项目名称" value="item_name"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="onSearchPatrolBut"></el-button>
            </el-input></div>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" row-key="id" stripe style="width: 100%" @sort-change="handlesortChange">
            <el-table-column align="center" type="index" label="序号" width="100"> </el-table-column>
            <el-table-column align="center" prop="device_id" label="设备id" sortable> </el-table-column>
            <el-table-column align="center" prop="GRM" label="设备序号" sortable> </el-table-column>
            <el-table-column align="center" prop="state" label="设备状态" sortable> </el-table-column>
            <el-table-column align="center" prop="realname" label="所属客户" sortable> </el-table-column>
            <el-table-column align="center" prop="item_name" label="项目名称" sortable> </el-table-column>
            <el-table-column align="center" prop="install_time" label="安装时间" sortable> </el-table-column>     

            <el-table-column align="center" label="操作" width="100">
                <template slot-scope="scope">
                <el-button @click="handleClick(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
            
        <div class="pageWrap">
            <el-pagination background layout="prev, pager, next" :hide-on-single-page="true" :current-page.sync="pageData.current_page" :page-size="pageData.per_page" :total="pageData.total" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import {apiEquipmentList} from "../../api/views/allList";
import {isNumbera, formatDate} from "../../utils/rules";
export default {
    data() {
        return {
            query:{
                page: 1,
				limit: null
            },
            pageData: {
                total: 0,
                per_page: 0,
            },
            tableData: [],
            searchPatrolSelectVal: '',
            searchPatrolVal: '',
        }
    },
    mounted() {

    },
    created:function() {
        this.getList({page:1})
    },
    methods: {
        getList(query){
            let stateMap = {
                1:'正常',
                2:'故障',
                3:'模块异常'
            }
            apiEquipmentList(query).then(res => {
                console.log(res)
                for(let i of res.data) {
                    i.install_time = isNumbera(i.install_time)&&(i.install_time + '').length===10?formatDate(i.install_time*1000):'尚未完成安装'
                    i.state = stateMap[i.state]
                }
                this.pageData = res
                this.tableData = res.data
            })
        },
        handleCurrentChange: function(currentPage){
            this.query.page = currentPage
            this.getList(this.query)
        },
        handleClick(row) {
            console.log(row)
            this.$router.push({path:'/customer/equipment-details',query:{
                id: row.id
            }})
        },
        onSearchPatrolBut(){
            console.log('搜索')
            this.query = {}
            this.query[this.searchPatrolSelectVal] = this.searchPatrolVal
            this.query.page = 1
            if(this.searchPatrolSelectVal && this.searchPatrolVal){
                this.getList(this.query)
            }else if(!this.searchPatrolSelectVal){
                this.$message({
                    message: '搜索类型不能为空',
                    type: "error"
                })
            }else if(!this.searchPatrolVal){
                this.$message({
                    message: '搜索内容不能为空',
                    type: "error"
                })
            }
            // this.pageData.current_page = 1
        },
        handlesortChange(column) {
            // console.log(column)
            // console.log(column.order)
            // console.log(column.prop)
            this.query = {}
            if (column.order == "ascending") this.query.sort_time = 1
            if (column.order == "descending") this.query.sort_time = 2
            this.getList(this.query)
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
